import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const getPing = async () => {
  const res = await fetch('https://logica-gw.ciat.net.ua/ws/api/PING');
  return res.status;
};

const TimeOut = 12000;

function LogicaPing({ available, handleAvailable }) {
  useEffect(() => {
    const ping = () => getPing().then((res) => {
      if (res !== 200) { return handleAvailable(false); }
      if (res === 200) { return handleAvailable(true); }
      return null;
    });
    ping();
    const isPing = setInterval(ping, TimeOut);
    return () => clearInterval(isPing);
  }, [handleAvailable]);
  return !available ? (
    <h2 style={{ color: 'red' }}>
      Нажаль, сервіс Логіки не відповідає
    </h2>
  ) : null;
}

LogicaPing.propTypes = {
  available: PropTypes.bool.isRequired,
  handleAvailable: PropTypes.func.isRequired,
};

export default LogicaPing;
